const api = import.meta.env.VITE_API;

export const SERVER_ADDRESSES = {
  API: api,
};

export const SERVER_APPLICATION_NAMES = {
  API: "API",
};
